<template>
  <div>
    <b-card :title="current_title">
      <b-row class="mb-4">
        <b-col md="12">
          <b-form-radio-group
            button-variant="outline-primary"
            v-model="current_param.IsExclusion"
          >
            <b-form-radio v-bind:value="false">Include (default) </b-form-radio>
            <b-form-radio v-bind:value="true"
              >Exclude (Include everything except selected)
            </b-form-radio>
          </b-form-radio-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <treeselect
            class="mb-4"
            style="width: 500px;"
            v-model="current_param.SelectedOptionInts"
            :multiple="true"
            :options="current_param.AvailableOptions"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-button size="md" variant="primary" @click="update">
            Update
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "LPParameterContainer",
  props: {
    lpfilter_object: { type: Object },
    param_object: { type: Object },
    param_title: { type: String }
  },
  data() {
    return {
      selected_values: [],
      current_lpfilter: this.lpfilter_object,
      current_param: this.param_object,
      current_title: this.param_title
    };
  },
  components: {
    Treeselect
  },
  methods: {
    async update() {
      await this.$store.dispatch("lpfilter/saveLPParam", this.current_param);
    }
  }
};
</script>

<style lang="scss" scoped></style>
